<template>
  <div class="dashboard">

    <dashboard-info-widgets ref="infoWidgets"></dashboard-info-widgets>

    <vuestic-widget class="no-padding no-v-padding">
      <vuestic-tabs
        :names="[$t('dashboard.dataVisualization')]"
        ref="tabs">
        <div :slot="$t('dashboard.dataVisualization')">
          <data-visualisation-tab ref="tab1" :table-data="tableData"></data-visualisation-tab>
        </div>
      </vuestic-tabs>
    </vuestic-widget>

  </div>
</template>

<script>
  import DashboardInfoWidgets from './DashboardInfoWidgets'
  import UsersMembersTab from './users-and-members-tab/UsersMembersTab.vue'
  import SetupProfileTab from './setup-profile-tab/SetupProfileTab.vue'
  import FeaturesTab from './features-tab/FeaturesTab.vue'
  import DataVisualisationTab from './data-visualisation-tab/DataVisualisation.vue'
  import DashboardBottomWidgets from './DashboardBottomWidgets.vue'

  import store from '../../store'
  import ajax from 'services/ajax'

  export default {
    name: 'dashboard',
    components: {
      DataVisualisationTab,
      DashboardInfoWidgets,
      UsersMembersTab,
      SetupProfileTab,
      FeaturesTab,
      DashboardBottomWidgets
    },
    data () {
      return {
        tableData: {
          'data': []
        }
      }
    },
    created () {
      store.commit('setLoading', true)
      ajax.run(this, 'customer/dashboard', (data) => {
        store.commit('setLoading', false)
        this.$refs.infoWidgets.setData(data)

        this.tableData = {
          'data': data.vms
        }

        this.tableData.data.push(...data.vpsImproving)

      }, (error) => {
        store.commit('setLoading', false)
        console.log(error)
      })
    },
    mounted () {
      //console.log(localStorage.getItem('token'))
    },
    methods: {
      launchEpicmaxToast () {
        this.showToast(`Let's work together!`, {
          icon: 'fa-star-o',
          position: 'top-right',
          duration: Infinity,
          action: {
            text: 'Hire us',
            href: 'http://epicmax.co/#/contact',
            class: 'vuestic-toasted-link'
          }
        })
      }
    }
  }

</script>
<style lang="scss" scoped>
  @import "../../sass/_variables.scss";
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue